<template>
  <div>
    <table class="table">
      <thead>
        <tr>
          <th>STT</th>
          <th>Mã nhân viên</th>
          <th>Tên nhân viên</th>
          <th>Doanh thu trong tháng</th>
          <th>So cùng kỳ tháng trước</th>
        </tr>
      </thead>
      <tbody v-for="item in items" :key="item.name">
        <tr>
          <!-- <td>{{ item.image }}</td> -->
          <td class="text-center">
            <img
              v-bind:src="'' + item.image"
              alt="ảnh nhân viên"
              class="img-user"
            />
          </td>
          <td class="text-center">{{ String(Math.random()).slice(3, 7) }}</td>
          <td class="text-center">{{ item.ten_nv }}</td>
          <td class="text-center">
            {{
              String(Math.floor(Math.random() * 10000000)).replace(
                /\B(?=(\d{3})+(?!\d))/g,
                ","
              )
            }}
          </td>
          <td class="text-center">
            {{ "+" + Math.floor(Math.random() * 100) + "%" }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: "List",
  data() {
    return {
      items: [
        {
          image:
            "https://hthaostudio.com/wp-content/uploads/2020/07/Thanh-dat-xanh-2-1180x760.jpg",
          ten_nv: "Park Hang Seo",
        },
        {
          image:
            "https://img.timviec.com.vn/2020/10/luong-nhan-vien-van-phong-1.jpg",
          ten_nv: "Nguyễn Quang Hải",
        },
        {
          image:
            "https://file.tinnhac.com/resize/600x-/2019/06/30/20190630131518-e0ea.jpg",
          ten_nv: "Trần Duy Tâm",
        },
        {
          image:
            "http://congtyluatdragon.vn/images/news/Doa-tung-anh-khach-khoa-than-len-mang-nhan-vien-nha-nghi-co-the-doi-dien-an-5-nam-tu-luat-su-nguyen-trung-tiep-1565535663-868-width660height440.jpg",
          ten_nv: "Leo Công Phượng",
        },
        {
          image:
            "http://media.doisongphapluat.com/448/2015/9/28/doi%20ve%20dspl2.jpg",
          ten_nv: "Ly Canh Sa",
        },
        {
          image: "http://media.vietq.vn/files/mr_Tien.jpg",
          ma_nhan_vien: "4125",
          ten_nv: "Mai Tùng Lâm",
        },
        {
          image:
            "https://thueketoan.vn/wp-content/uploads/2018/01/hinh-nhan-vien-2018-chi-Loc2.jpg",
          ten_nv: "Hoàng Hải Hưng",
        },
      ],
    };
  },
};
</script>
<style type="text/css">
tr > th {
  text-align: center !important;
}

.img-user {
  width: 50px;
  height: 50px;
  border-radius: 25px;
  object-fit: cover;
}
</style>
